/**
 * Packages
 */
import { Container, Row, Col } from 'react-bootstrap';
import Badge from '../../components/Badge';

/**
 * Styles
 */
import './index.scss';

/**
 * Filters component
 */
function Filters(props: any) {
  const { pageYOffset } = props;

  const scaleSmall: number = pageYOffset < 860 ? 1 : 1 + ((pageYOffset - 860) * 0.00030);
  const scaleLarge: number = pageYOffset < 860 ? 1 : 1 - ((pageYOffset - 860) * 0.00030);

  const styleSmall: any = { transform: `scale(${scaleSmall})` };
  const styleLarge: any = { transform: `scale(${scaleLarge})` };

  return (
    <section className='Filters'>
      <Container>
        <Row>
          <Col sm={{ span: 12 }} className="text-center">
            {/* Images */}
            <div className='d-block d-md-none'>
              <div className="Filters__topology-img"></div>
              <div className="Filters__filters-airlines-img" style={styleSmall}></div>
              <div className="Filters__filters-banking-img" style={styleSmall}></div>
              <div className="Filters__filters-biotech-img" style={styleLarge}></div>
              <div className="Filters__filters-cannabis-img" style={styleLarge}></div>
              <div className="Filters__filters-crypto-img" style={styleLarge}></div>
              <div className="Filters__filters-energy-img" style={styleLarge}></div>
              <div className="Filters__filters-europe-img" style={styleLarge}></div>
              <div className="Filters__filters-finance-img" style={styleLarge}></div>
              <div className="Filters__filters-fintech-img" style={styleLarge}></div>
              <div className="Filters__filters-pharma-img" style={styleSmall}></div>
              <div className="Filters__filters-realestate-img" style={styleLarge}></div>
              <div className="Filters__filters-technology-img" style={styleLarge}></div>
            </div>

            {/* Badges */}
            <div className='d-none d-md-block'>
              <Badge text="AI 🤖" color='green' size='large' top='190px' left='-90px' width='214px' height='74px' transform={styleLarge.transform} />
              <Badge text="Quantum 💻" color="green" size='medium' top='183px' left='995px' width='254px' height='71px' transform={styleLarge.transform} />
              <Badge text="AI Energy ⚡" color="black" size='medium' top='441px' left='-20px' width='330px' height='76px' transform={styleLarge.transform} />
              <Badge text="Biotech 🔬" color="black" size='small' top='561px' left='-147px' width='170px' height='48px' transform={styleSmall.transform} />
              <Badge text="AI Infrastructure 🇪🇺" color='green' size='medium' top='561px' left='78px' width='364px' height='78px' transform={styleLarge.transform} />
              <Badge text="Nuclear ☢️" color='black' size='medium' top='520px' left='560px' width='238px' height='70px' transform={styleLarge.transform} />
              <Badge text="🏆 AI Leaders" color='green' size='medium' top='577px' left='936px' width='230px' height='68px' transform={styleLarge.transform} />
              <Badge text="Banking 💰" color='green' size='small' top='706px' left='1px' width='247px' height='69px' transform={styleSmall.transform} />
              <Badge text="Battery & Storage 🔋" color='black' size='medium' top='729px' left='332px' width='349px' height='71px' transform={styleLarge.transform} />
              <Badge text="Crypto 🔑" color='green' size='small' top='696px' left='773px' width='170px' height='48px' transform={styleSmall.transform} />
              <Badge text="Energy ⚡️" color='black' size='small' top='791px' left='1012px' width='159px' height='48px' transform={styleSmall.transform} />
              <Badge text="Fintech 📱" color='green' size='small' top='839px' left='735px' width='141px' height='48px' transform={styleSmall.transform} />
            </div>

            {/* Text */}
            <p className='Filters__pretitle'></p>
            <h2 className='Filters__title'>Discover Hidden <br className='d-none d-md-block' />Gems Instantly</h2>
            <p className='Filters__subtitle'>
              Filter by top themes like AI, AI Energy, AI Infrastructure, <br className='d-none d-md-block' />Quantum Computing, Nuclear Energy and more
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Filters;